export default __webpack_public_path__ + "static/media/Blue check.df24241a.svg";